import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { CookiePolicy } from './pages/CookiePolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Disclaimer } from './pages/Disclaimer';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { About } from './pages/About';
export function App() {
  return <Routes data-id="element-0" data-mp="2rit3v7n2pyrh">
      <Route path="/" element={<Home data-id="element-2" data-mp="2mmcbu2cr7094" />} data-id="element-1" data-mp="2mlu9cnzhzpsr" />
      <Route path="/cookie-policy" element={<CookiePolicy data-id="element-4" data-mp="2mjpw3ffpleft" />} data-id="element-3" data-mp="2mmvjmq8ow89f" />
      <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-6" data-mp="31brz38d2snk2" />} data-id="element-5" data-mp="31agmqk5ke7hc" />
      <Route path="/terms" element={<TermsAndConditions data-id="element-8" data-mp="2wk0av4he6tx3" />} data-id="element-7" data-mp="31c1iue7j1yhb" />
      <Route path="/disclaimer" element={<Disclaimer data-id="element-10" data-mp="2wip7h5ruzo6i" />} data-id="element-9" data-mp="2wiyxuugtfxcq" />
      <Route path="/contact" element={<Contact data-id="element-12" data-mp="28tmfp53igeya" />} data-id="element-11" data-mp="28ufpkexrnkkn" />
      <Route path="/faq" element={<FAQ data-id="element-14" data-mp="28sbcb6dz997p" />} data-id="element-13" data-mp="28t4kmbsl46ry" />
      <Route path="/about" element={<About data-id="element-16" data-mp="23w4fq47h1a2f" />} data-id="element-15" data-mp="23vciyq2516ak" />
    </Routes>;
}